import type { RegulatoryPolicy } from './types';

const REGULATED_SESSION_POLICY: Partial<RegulatoryPolicy> = {
  autoplay: false,
  dualBet: true,
  chat: true,
  keyboardBetting: false,
  autoCashout: true,
  centerAutoCashout: true,
  winCelebration: 'all',
  rulesSections: [
    'bet_cash_out',
    'auto_cash_out',
    'live_bets',
    'randomization',
    'game_menu',
    'other',
  ],
  rulesThirdPartyUiDisclaimer: true,
  sessionDisplays: true,
};

export const UK_POLICY: Partial<RegulatoryPolicy> = {
  ...REGULATED_SESSION_POLICY,
  jurisdiction: 'UK',
};

export const ONT_POLICY: Partial<RegulatoryPolicy> = {
  ...REGULATED_SESSION_POLICY,
  jurisdiction: 'ONT',
};

export const AB_POLICY: Partial<RegulatoryPolicy> = {
  ...REGULATED_SESSION_POLICY,
  jurisdiction: 'AB',
};

/**
 * Spain — keep ISO currency codes (EUR, USD, …) in all monetary UI.
 * Isolated override so future Spain-only rules do not affect other markets.
 */
export const ES_POLICY: Partial<RegulatoryPolicy> = {
  jurisdiction: 'ES',
  useCurrencySymbol: false,
};

export const JURISDICTION_PROFILES: Record<
  string,
  Partial<RegulatoryPolicy>
> = {
  UK: UK_POLICY,
  UKGC: UK_POLICY,
  GB: UK_POLICY,
  ONT: ONT_POLICY,
  ON: ONT_POLICY,
  ONTARIO: ONT_POLICY,
  'CA-ON': ONT_POLICY,
  CA_ON: ONT_POLICY,
  AB: AB_POLICY,
  ALBERTA: AB_POLICY,
  'CA-AB': AB_POLICY,
  CA_AB: AB_POLICY,
  ES: ES_POLICY,
  ESP: ES_POLICY,
  SPAIN: ES_POLICY,
  'ES-ES': ES_POLICY,
};
